"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCustomInterception = void 0;
var logger_1 = require("./logger");
var util_1 = require("./util");
function resolveNotifyMessage(notifyMessage) {
    var defaultNotify = function (options) {
        var messages = [options === null || options === void 0 ? void 0 : options.title, options.message];
        (0, logger_1.logError)(messages.filter(Boolean).join('，'));
    };
    return notifyMessage !== null && notifyMessage !== void 0 ? notifyMessage : defaultNotify;
}
function resolveShowErrorMessage(showErrorMessage) {
    return showErrorMessage !== null && showErrorMessage !== void 0 ? showErrorMessage : true;
}
function resolveExtractData(extractData) {
    if (typeof extractData === 'function') {
        return extractData;
    }
    if (extractData === false) {
        return util_1.identity;
    }
    return function (data) { return data === null || data === void 0 ? void 0 : data.data; };
}
function resolveExtractErrorMessage(extractErrorMessage) {
    if (typeof extractErrorMessage === 'function') {
        return extractErrorMessage;
    }
    return function (data) { return (data === null || data === void 0 ? void 0 : data.msg) || (data === null || data === void 0 ? void 0 : data.message); };
}
function resolveIsUnauthorized(isUnauthorized) {
    if (typeof isUnauthorized === 'function') {
        return isUnauthorized;
    }
    // 授权失败时，sso会返回status字段401
    return function (response) { var _a, _b; return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) === 401 || ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.status) === 401; };
}
function resolveValidateResponse(validateResponse) {
    if (typeof validateResponse === 'function') {
        return validateResponse;
    }
    return function (data) { return (data === null || data === void 0 ? void 0 : data.code) === 0; };
}
function resolveTransformResponse(transformers) {
    var mergedTransformers = [];
    transformers.forEach(function (transformer) {
        if (Array.isArray(transformer)) {
            mergedTransformers = mergedTransformers.concat(transformer);
        }
        else if (!(0, util_1.isNullOrUndefined)(transformer)) {
            mergedTransformers.push(transformer);
        }
    });
    return function (data, headers) {
        for (var _i = 0, mergedTransformers_1 = mergedTransformers; _i < mergedTransformers_1.length; _i++) {
            var transformer = mergedTransformers_1[_i];
            data = transformer(data, headers);
        }
        return data;
    };
}
function resolveCustomInterception(baseLevel, requestLevel) {
    var config = (0, util_1.mergeObjects)(baseLevel, requestLevel);
    var extractData = config.extractData, extractErrorMessage = config.extractErrorMessage, notifyMessage = config.notifyMessage, rethrowError = config.rethrowError, validateResponse = config.validateResponse, showErrorMessage = config.showErrorMessage, isUnauthorized = config.isUnauthorized;
    return {
        notifyMessage: resolveNotifyMessage(notifyMessage),
        showErrorMessage: resolveShowErrorMessage(showErrorMessage),
        extractData: resolveExtractData(extractData),
        extractErrorMessage: resolveExtractErrorMessage(extractErrorMessage),
        rethrowError: (0, util_1.getBoolean)(rethrowError, false),
        validateResponse: resolveValidateResponse(validateResponse),
        transformResponse: resolveTransformResponse([
            baseLevel === null || baseLevel === void 0 ? void 0 : baseLevel.transformResponse,
            requestLevel === null || requestLevel === void 0 ? void 0 : requestLevel.transformResponse,
        ]),
        isUnauthorized: resolveIsUnauthorized(isUnauthorized),
    };
}
exports.resolveCustomInterception = resolveCustomInterception;
